/**
 * 设置localStorage
 * @param key
 * @param value
 * @param expire(单位：h)
 */
export function setCookie(key, value, expire) {
    localStorage.setItem(key, JSON.stringify(value));
    if (expire) {
        let time = Date.now() + 1000 * 60 * 60 * expire;
        localStorage.setItem('expire', time);
    }
}

/**
 * 获取localStorage
 * @param key
 */
export function getCookie(key) {
    let expire = localStorage.getItem('expire') || Date.now() + 1;
    const now = Date.now();
    if (now >= expire) {
        localStorage.clear();
        window.location.href = '/ud-backstage/';
        return;
    }
    const value = localStorage.getItem(key);
    return value;
}
